var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg004PlaneBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "80px",
    viewBox: "0 0 77 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "004-plane") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-8.2%",
    y: "-30.4%",
    width: "116.4%",
    height: "160.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.114082817 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JetOS-v3-/-Lightmode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JetOS-Light/v3/01.1-Dashboard-new",
    transform: "translate(-378.000000, -268.000000)",
    fill: "#70C8FC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONTENT",
    transform: "translate(375.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(1.000000, 75.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "004-plane",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7958081,19.5038803 L20.2678941,12.0264132 L20.2678941,3.77149925 C20.2678941,1.69193286 18.5775858,0 16.4997893,0 C14.422063,0 12.7317547,1.69193286 12.7317547,3.77149925 L12.7317547,11.9812021 L1.19843155,19.504935 C0.448041996,19.9943812 0,20.8218203 0,21.7183766 C0,22.5419485 0.373227834,23.3035046 1.02386517,23.8076462 C1.67464301,24.3117877 2.5046236,24.4825771 3.30116612,24.2759986 L12.7316844,21.8320721 L12.7316844,26.6674015 L7.50663525,30.7214872 C6.79228293,31.2757617 6.36580709,32.1467946 6.36580709,33.0514369 C6.36511349,34.0320501 6.85227487,34.9486376 7.66511482,35.4960665 C8.47715584,36.0446451 9.50876501,36.1525723 10.41659,35.7839264 L16.5,33.318414 L22.58341,35.784067 C23.4912476,36.1526238 24.5228134,36.0447012 25.3348852,35.4962071 C26.1477442,34.9487954 26.6349114,34.032197 26.6341929,33.0515775 C26.6341929,32.1468649 26.2076468,31.275832 25.4932243,30.7215575 L20.2680346,26.6678937 L20.2680346,21.8487362 L29.7023463,24.2797955 C30.4983268,24.4848271 31.3277454,24.3134752 31.9775398,23.8093337 C32.6272639,23.3051921 33,22.5441282 33,21.7211891 L33,21.7209782 C33,20.8218203 32.5497803,19.9929749 31.7958081,19.5038803 L31.7958081,19.5038803 Z M30.8202033,21.7212594 C30.8202033,21.917502 30.7085792,22.0333069 30.6421246,22.0849164 C30.5756699,22.1364555 30.4356656,22.2157682 30.2459256,22.1668306 L19.4499259,19.3849113 C19.1235631,19.3007528 18.7766604,19.3724399 18.510282,19.5790877 C18.2439037,19.7857355 18.0880134,20.1040993 18.0880272,20.4414289 L18.0880272,27.202551 C18.0880272,27.5398406 18.2439076,27.8582162 18.5102881,28.0647948 L24.1575983,32.4459748 C24.3452778,32.5905688 24.4549088,32.8144519 24.4541153,33.0515072 C24.4541153,33.4193829 24.2179413,33.6182973 24.1164329,33.6867818 C24.0149948,33.755196 23.7420109,33.8996182 23.4014484,33.7615242 L16.9091246,31.1300036 C16.6466778,31.0236348 16.3531817,31.0236348 16.0907349,31.1300036 L9.59841112,33.7615242 C9.25777837,33.8994776 8.98493499,33.755196 8.88342657,33.6867818 C8.78191815,33.6182973 8.54574425,33.4193126 8.54574425,33.0514369 C8.54574425,32.8127958 8.65378573,32.5921548 8.84219097,32.4459748 L14.4893606,28.0643026 C14.7556794,27.8576557 14.9115398,27.5393407 14.9115513,27.2020588 L14.9115513,20.4226554 C14.9115582,20.0851187 14.7554609,19.7665894 14.4887915,19.5599796 C14.222122,19.3533697 13.8749191,19.2819525 13.5484584,19.3665597 L2.75484711,22.1638071 C2.56503691,22.213026 2.42482183,22.133854 2.35822668,22.0821742 C2.29156129,22.030635 2.17993716,21.9146895 2.17993716,21.7183063 C2.17993716,21.5622123 2.25791248,21.4180714 2.38871433,21.3328525 L14.4169349,13.4863846 C14.7256078,13.2850076 14.9117515,12.941182 14.9117621,12.5723907 L14.9117621,3.77149925 C14.9117621,2.89498199 15.6242177,2.18187127 16.5,2.18187127 C17.3757121,2.18187127 18.0881677,2.89498199 18.0881677,3.77149925 L18.0881677,12.6194299 C18.0881935,12.989227 18.2753494,13.3338437 18.5853833,13.5349707 L30.6103724,21.3348212 C30.7414048,21.419444 30.8202033,21.5649652 30.8202033,21.7210485 L30.8202033,21.7212594 L30.8202033,21.7212594 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg004PlaneBlue);
export default __webpack_public_path__ + "static/media/004-plane-blue.b679aa19.svg";
export { ForwardRef as ReactComponent };